<template>
  <header>
    <div id="nav" class="col">
      <img class="logo" src="/static/img/logo.png">
      <div class="header_title">江西聚小宝科技有限公司</div>
      <div class="nav-item">
        <ul>
          <li @mouseover="addClass(item.link,$event)" @mouseleave="rmClass(item.link,$event)" v-for="item in navItems" @click="toLink(item.link,$event)">{{item.text}}</li>
        </ul>
      </div>
    </div>
  </header>
</template>

<script>
const navItems = [
  {
    text: "首页",
    fit_text: "Home",
    link: "/",
  },
  {
    text: "产品中心",
    fit_text: "About us",
    link: "/about",
  },
  {
    text: "技术支持",
    fit_text: "product",
    link: "/product",
  },
  {
    text: "成功案例",
    fit_text: "project",
    link: "/partnersList",
  },
  {
    text: "关于我们",
    fit_text: "news",
    link: "/newsList",
  },
];
import router from "../router";
export default {
  name: "header",
  data() {
    return {
      navItems: navItems,
      navIn: "nav-out",
      navActionView: "none",
    };
  },
  methods: {
    toLink(link, $event) {
      [].forEach.call(document.getElementsByTagName("li"), function (item) {
        item.className = "";
      });
      $event.target.className = "selected";
      if (link == "/product") {
        this.navActionView = "";
      } else {
        this.navActionView = "none";
      }
      router.push(link || "/");
    },

    toLinkAction(link) {
      this.navActionView = "none";
      router.push(link || "/");
    },

    addClass(link, $event) {
      if (
        !$event.target.className.match(
          new RegExp("(\\s|^)" + "selected" + "(\\s|$)")
        )
      ) {
        $event.target.className = " ";
      }
      if (
        !$event.target.className.match(
          new RegExp("(\\s|^)" + "nav-in" + "(\\s|$)")
        )
      ) {
        $event.target.className += " " + "nav-in";
      }
      if (link == "/product") {
        this.navActionView = "";
      } else {
        this.navActionView = "none";
      }
    },
    rmClass(link, $event) {
      if (
        !$event.target.className.match(
          new RegExp("(\\s|^)" + "selected" + "(\\s|$)")
        )
      ) {
        $event.target.className = " ";
      }
      if (
        !$event.target.className.match(
          new RegExp("(\\s|^)" + "nav-out" + "(\\s|$)")
        )
      ) {
        $event.target.className += " " + "nav-out";
      }
      if (link == "/product") {
        this.navActionView = "";
      } else {
        this.navActionView = "none";
      }
    }
  },
};
</script>

<style lang='scss'>
header {
  width: 1920px;
  height: 130px;
  position: fixed;
  z-index: 9;
}
#nav {
  position: relative;
  width: 100%;
  height: 100%;
}
.logo {
  width: 68px;
  height: 68px;
  position: absolute;
  left: 180px;
  top: 56px;
  cursor: pointer;
}

.header_title {
  font-size: 32px;
  font-family: SourceHanSansCN;
  font-weight: bold;
  color: #ffffff;
  left: 261px;
  top: 70px;
  position: absolute;
}

.nav-item {
  ul {
    top: 0px;
    list-style: none;
    margin: 0;
    padding: 0;
    position: absolute;
    left:930px;
  }
}
li {
  width: 120px;
  height: 130px;
  line-height: 180px;
  font-family: MicrosoftYaHei;
  font-weight: 400;
  margin-left: 20px;
  cursor: pointer;
  float: left;
  font-size: 20px;
  color: #FFF;
}

.fit_text_view {
  position: absolute;
  top: 88px;
  left: 680px;
}

.fit_text {
  width: 120px;
  font-size: 12px;
  font-family: MicrosoftYaHei;
  font-weight: 400;
  color: #FFF;
  float: left;
  margin-left: 20px;
  text-align: center;
}

.selected {
  width: 120px;
  height: 150px;
  background-color: #FFF;
  color: #2850A2;
}
@mixin nav-in {
  @-webkit-keyframes navin {
    0% {
      color: #2850A2;
    }
    100% {
      width: 120px;
      height: 150px;
      background-color: #FFF;
    }
  }
  @-moz-keyframes navin {
    0% {
      color: #2850A2;
    }
    100% {
      width: 120px;
      height: 150px;
      background-color: #FFF;
      color: #2850A2;
    }
  }
  @-ms-keyframes navin {
    0% {
      color: #2850A2;
    }
    100% {
      width: 120px;
      height: 150px;
      background-color: #FFF;
      color: #2850A2;
    }
  }
  @-o-keyframes navin {
    0% {
      color: #2850A2;
    }
    100% {
      width: 120px;
      height: 150px;
      background-color: #FFF;
      color:#2850A2;
    }
  }
  @keyframes navin {
    0% {
      color: #2850A2;
    }
    100% {
      width: 120px;
      height: 150px;
      background-color: #FFF;
      color: #2850A2;
    }
  }
}
.nav-in {
  @include nav-in;
  -webkit-animation: navin 0.5s 0s ease both;
  -moz-animation: navin 0.5s 0s ease both;
  -ms-animation: navin 0.5s 0s ease both;
  -o-animation: navin 0.5s 0s ease both;
  animation: navin 0.5s 0s ease both;
}


.nav_action_item {
  width: 120px;
  height: 70px;
  background-color: #e62e78;
  text-align: center;
  line-height: 70px;
  color: #ffffff;
  cursor: pointer;
}

.nav_action_item_select {
  width: 120px;
  height: 70px;
  background-color: rgba(230, 46, 120, 0.9);
  text-align: center;
  line-height: 70px;
  color: #ffffff;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// header.vue?73105976